module.exports = __webpack_public_path__ + "ax.b7cb7e2a655b303241f5.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ax.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ax.svg
// module chunks = styles